/**
 * Authentication Token Helper
 * Token lives in memory only (never persisted). Session persistence across
 * reloads relies on the httpOnly session cookie set by the backend.
 * A non-sensitive boolean flag in localStorage hints that a session may exist.
 */

const LEGACY_TOKEN_KEY = 'metodo11_auth_token';
const LOGIN_FLAG_KEY = 'metodo11_logged_in';

let memoryToken = null;

// One-time migration: absorb any legacy persisted token into memory and wipe it
try {
  const legacy = localStorage.getItem(LEGACY_TOKEN_KEY);
  if (legacy) {
    memoryToken = legacy;
    localStorage.removeItem(LEGACY_TOKEN_KEY);
    localStorage.setItem(LOGIN_FLAG_KEY, '1');
  }
} catch (e) {
  console.debug('authHelper: storage unavailable', e);
}

export const authHelper = {
  saveToken(token) {
    if (token) {
      memoryToken = token;
      try {
        localStorage.setItem(LOGIN_FLAG_KEY, '1');
      } catch (e) {
        console.debug('authHelper: storage unavailable', e);
      }
    }
  },

  getToken() {
    return memoryToken;
  },

  removeToken() {
    memoryToken = null;
    try {
      localStorage.removeItem(LEGACY_TOKEN_KEY);
      localStorage.removeItem(LOGIN_FLAG_KEY);
    } catch (e) {
      console.debug('authHelper: storage unavailable', e);
    }
  },

  // Get auth headers for fetch requests (cookie covers auth after reloads)
  getAuthHeaders() {
    const headers = {
      'Content-Type': 'application/json'
    };

    if (memoryToken) {
      headers['Authorization'] = `Bearer ${memoryToken}`;
    }

    return headers;
  },

  // Check if user is (probably) logged in: memory token or session-cookie hint
  isAuthenticated() {
    if (memoryToken) return true;
    try {
      return localStorage.getItem(LOGIN_FLAG_KEY) === '1';
    } catch (e) {
      return false;
    }
  }
};
